module.exports = __webpack_public_path__ + "static/media/logout.b2eeb5c7.svg";